module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/mortgage.svg?7c3a306d290e5d2c5f4abf9b6e1b0006";